
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-today',
    templateUrl: './today.component.html',
    styleUrls: ['./today.component.scss', '../../../dashboard.scss'],
    standalone: false
})
export class TodayComponent {
    @Input() dashboardData: any;

    todaySalesTop: any;
    todaySalesBottom: any;
    todayStaffWorkingNowTop: any;
    todayStaffWorkingNowBottom: any;
    todaySalesValueByItemTop: any;
    todaySalesValueByItemBottom: any;
    todaySalesByLabourHourTop: any;
    todaySalesByLabourHourBottom: any;
    todayItemsSoldTop: any;
    todayItemsSoldBottom: any;
    todayLabourCostTop: any;
    todayLabourCostBottom: any;
    todayCustomerOrdersTop: any;
    todayCustomerOrdersBottom: any;
    todayLabourHoursTop: any;
    todayLabourHoursBottom: any;
    todayTargetTop: any;
    todayTargetBottom: any;
    salesTodayLyDif: any;
    todayLabourPerTop: any;
    todayLabourPerBottom: any;
    onlineSalesTodayTop: any;
    onlineSalesTodayBottom: any;
    onlineCustomerOrdersTodayTop: any;
    onlineCustomerOrdersTodayBottom: any;
    driveThruSalesTodayTop: any;
    driveThruSalesTodayBottom: any;
    driveThruOrdersTodayTop: any;
    driveThruOrdersTodayBottom: any;
    GST_VALUE: any;
    targetImg: any;
    shopType: any;

    ngOnChanges(changes: SimpleChanges) {
        if (changes['dashboardData']) {
            this.shopType = this.dashboardData?.sales_all_shops[0].shop_type;
            // -------Today Section-------

            // Declare dash_board_data first for all usages below
            const dash_board_data = this.dashboardData?.dashboard_data_v3?.[0];
            // -------Sales Card (Today Section)-------
            let sales_today = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.sales_today));
            this.todaySalesTop = sales_today;
            let label_1_1 = "-&nbsp;-";
            let last_year_same_day_sales = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_same_day_sales));
            if (last_year_same_day_sales > 0) {
                let sales_today_ly_diff = this.setDecimalPoints(sales_today - last_year_same_day_sales);
                let sales_today_ly_per = this.setDecimalPoints((sales_today_ly_diff / last_year_same_day_sales) * 100, 1);
                label_1_1 =
                    '<span class="ly-row">' + this.setFontColorWithUpDownArrow(sales_today_ly_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
                    '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(sales_today_ly_diff, '$', false, 0) + ' LY' + '</span>';
            }
            this.todaySalesBottom = label_1_1;
            // console.log(dash_board_data )
            // Labour%
            this.GST_VALUE = dash_board_data?.gst_value ?? 1; // fallback to 1 to avoid division by zero

            if (dash_board_data?.sales_today > 0) {
                const sales_today = dash_board_data.sales_today;
                const today_sales_wo_gst = sales_today / this.GST_VALUE;
                const today_labour_per = this.fnCheckNull((dash_board_data.today_labour_cost / today_sales_wo_gst) * 100);
                this.todayLabourPerTop = this.setDecimalPoints(today_labour_per) + '%';

                const today_roster_sale_forecast = this.fnCheckNull(dash_board_data.sales_forecast_today);
                const today_roster_labour_per = this.setDecimalPoints(
                    (dash_board_data.today_roster_labor_cost / (today_roster_sale_forecast / this.GST_VALUE)) * 100
                );

                const today_labour_per_diff = this.setDecimalPoints(today_labour_per - today_roster_labour_per);

                let label_1_2 = '-&nbsp;-';
                if (dash_board_data.last_year_same_day_sales > 0) {
                    const last_year_same_day_sales_wo_gst = this.setDecimalPoints(dash_board_data.last_year_same_day_sales / this.GST_VALUE);
                    const last_year_same_day_labor_per = this.setDecimalPoints(
                        (dash_board_data.last_year_same_day_labor_cost / last_year_same_day_sales_wo_gst) * 100
                    );
                    const last_year_same_day_labor_per_diff = this.setDecimalPoints(today_labour_per - last_year_same_day_labor_per);

                    const targetImg = "<img class='target-arrow' src='assets/images/target_img.png' style='height:16px;vertical-align:middle;'/>";
                    console.log(today_labour_per_diff);
                    label_1_2 =
                        '<span class="ly-row">' + this.setFontColorWithUpDownArrow(today_labour_per_diff, '%', true,1) + '</span>' +
                        ' ' + targetImg + ' &nbsp; ' +
                        '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(last_year_same_day_labor_per_diff, '%', true) + '</span>'
                    ' LY';
                }
                this.todayLabourPerBottom = label_1_2;
            } else {
                this.todayLabourPerTop = '0';
                this.todayLabourPerBottom = '--';
            }

            // -------Online Sales Card (Today Section)-------
            const online_sales_today = this.fnCheckNull(dash_board_data?.today_online_sales);
            const online_sales_today_val = this.setDecimalPoints(online_sales_today);
            this.onlineSalesTodayTop = online_sales_today_val;
            const last_year_same_day_online_sales = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_same_day_online_sales));
            let label_2_1_new = "-&nbsp;-";
            if (last_year_same_day_online_sales > 0) {
                let online_sales_today_ly_diff = this.setDecimalPoints(online_sales_today_val - last_year_same_day_online_sales);
                let online_sales_today_ly_per = this.setDecimalPoints((online_sales_today_ly_diff / last_year_same_day_online_sales) * 100);
                label_2_1_new =
                    '<span class="ly-row">' + this.setFontColorWithUpDownArrow(online_sales_today_ly_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
                    '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(online_sales_today_ly_diff, '$', false, 0) + ' LY' + '</span>';
            }
            this.onlineSalesTodayBottom = label_2_1_new;

            // -------Online Customer Orders Card (Today Section)-------
            const online_sales_count_today = this.fnCheckNull(dash_board_data?.today_online_sales_count);
            this.onlineCustomerOrdersTodayTop = online_sales_count_today;
            const last_year_same_day_online_sales_count = this.fnCheckNull(dash_board_data?.last_year_same_day_online_sales_count);
            let label_2_2_online_new = "-&nbsp;-";
            if (last_year_same_day_online_sales_count > 0) {
                let online_sales_count_today_ly_diff = this.setDecimalPoints(online_sales_count_today - last_year_same_day_online_sales_count, 0);
                let online_sales_count_today_ly_per = this.setDecimalPoints((online_sales_count_today_ly_diff / last_year_same_day_online_sales_count) * 100, 1);
                label_2_2_online_new =
                    '<span class="ly-row">' + this.setFontColorWithUpDownArrow(online_sales_count_today_ly_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
                    '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(online_sales_count_today_ly_diff, '', false, 0) + ' LY' + '</span>';
            }
            this.onlineCustomerOrdersTodayBottom = label_2_2_online_new;

            // -------Drive-Thru Sales Card (Today Section)-------
            const today_dt_sales = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.today_dt_sales));
            this.driveThruSalesTodayTop = today_dt_sales;
            const last_year_same_day_dt_sales = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_same_day_dt_sales));
            let label_2_1_new_1 = "-&nbsp;-";
            if (last_year_same_day_dt_sales > 0) {
                let dt_sales_today_ly_diff = this.setDecimalPoints(today_dt_sales - last_year_same_day_dt_sales, 0);
                let dt_sales_today_ly_per = this.setDecimalPoints((dt_sales_today_ly_diff / last_year_same_day_dt_sales) * 100, 1);
                label_2_1_new_1 =
                    '<span class="ly-row">' + this.setFontColorWithUpDownArrow(dt_sales_today_ly_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
                    '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(dt_sales_today_ly_diff, '$', false, 0) + ' LY' + '</span>';
            }
            this.driveThruSalesTodayBottom = label_2_1_new_1;

            // -------Drive-Thru Orders Card (Today Section)-------
            const dt_sales_count_today = this.fnCheckNull(dash_board_data?.today_dt_sales_count);
            this.driveThruOrdersTodayTop = dt_sales_count_today;
            const last_year_same_day_dt_sales_count = this.fnCheckNull(dash_board_data?.last_year_same_day_dt_sales_count);
            let label_2_2_drive_thru_new = "-&nbsp;-";
            if (last_year_same_day_dt_sales_count > 0) {
                let dt_sales_count_today_ly_diff = this.setDecimalPoints(dt_sales_count_today - last_year_same_day_dt_sales_count, 0);
                let dt_sales_count_today_ly_per = this.setDecimalPoints((dt_sales_count_today_ly_diff / last_year_same_day_dt_sales_count) * 100, 1);
                label_2_2_drive_thru_new =
                    '<span class="ly-row">' + this.setFontColorWithUpDownArrow(dt_sales_count_today_ly_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
                    '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(dt_sales_count_today_ly_diff, '', false, 0) + ' LY' + '</span>';
            }
            this.driveThruOrdersTodayBottom = label_2_2_drive_thru_new;

            // -------TARGET Card (Today Section)-------
            const today_target = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.today_target));
            this.todayTargetTop = today_target;

            const today_target_vari = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.sales_today - dash_board_data?.today_target));
            const today_target_perc = this.setDecimalPoints(this.fnCheckNull(((dash_board_data?.sales_today - dash_board_data?.today_target) / dash_board_data?.today_target) * 100));
            this.targetImg = "<img class='target-arrow' src='assets/images/target_img.png' style='height:16px;vertical-align:middle;'/>";
            let label_1_2_target =
                '<span class="ly-row">' + this.setFontColorWithUpDownArrow(today_target_perc, "%", false,1) + this.targetImg + ' &nbsp; ' + '</span>' +
                '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(today_target_vari, "$", false, 0) + this.targetImg + ' &nbsp; ' + '</span>';
            this.todayTargetBottom = label_1_2_target;

            // -------LABOUR HOURS Card (Today Section)-------
            const today_labour_hours = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.today_labour_hours), 0);
            this.todayLabourHoursTop = today_labour_hours;
            let label_1_2_labour_hours = "-&nbsp;-";
            const last_year_same_day_labor_hours = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_same_day_labor_hours), 0);
            if (last_year_same_day_labor_hours > 0) {
                const today_roster_labor_hours = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.today_roster_labor_hours), 0);
                const today_labour_hours_diff = this.setDecimalPoints(today_labour_hours - today_roster_labor_hours);
                const today_labour_hours_ly = this.setDecimalPoints(today_labour_hours - last_year_same_day_labor_hours);
                const targetImg = "<img class='target-arrow' src='assets/images/target_img.png' style='height:16px;vertical-align:middle;'/>";
                label_1_2_labour_hours =
                    '<span class="ly-row">' + this.setFontColorWithUpDownArrow(today_labour_hours_diff, '', true, 0) + targetImg + ' &nbsp; ' + '</span>' +
                    '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(today_labour_hours_ly, '', true, 0) + ' LY' + '</span>';
            }
            this.todayLabourHoursBottom = label_1_2_labour_hours;

            // -------CUSTOMER ORDERS Card (Today Section)-------
            const today_no_of_cust_orders = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.today_no_of_cust_orders), 0);
            this.todayCustomerOrdersTop = today_no_of_cust_orders;
            let label_1_2_customer_orders = "-&nbsp;-";
            const last_year_same_day_customer_orders = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_same_day_customer_orders), 0);
            if (last_year_same_day_customer_orders > 0) {
                const today_no_of_cust_orders_ly_diff = this.setDecimalPoints(today_no_of_cust_orders - last_year_same_day_customer_orders, 0);
                const today_no_of_cust_orders_per = this.setDecimalPoints((today_no_of_cust_orders_ly_diff / last_year_same_day_customer_orders) * 100, 1);
                label_1_2_customer_orders =
                    '<span class="ly-row">' + this.setFontColorWithUpDownArrow(today_no_of_cust_orders_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
                    '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(today_no_of_cust_orders_ly_diff, '', false, 0) + ' LY' + '</span>';
            }
            this.todayCustomerOrdersBottom = label_1_2_customer_orders;
            // -------LABOUR COST Card (Today Section)-------
            const today_labour_cost = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.today_labour_cost), 0);
            this.todayLabourCostTop = today_labour_cost;
            let label_1_2_labour_cost = "-&nbsp;-";
            const last_year_same_day_labor_cost = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_same_day_labor_cost), 0);
            if (last_year_same_day_labor_cost > 0) {
                const today_roster_labor_cost = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.today_roster_labor_cost), 0);
                const today_labour_cost_roster_diff = this.setDecimalPoints(today_labour_cost - today_roster_labor_cost);
                const today_labour_cost_ly_diff = this.setDecimalPoints(today_labour_cost - last_year_same_day_labor_cost);
                const targetImg = "<img class='target-arrow' src='assets/images/target_img.png' style='height:16px;vertical-align:middle;'/>";
                label_1_2_labour_cost =
                    '<span class="ly-row">' + this.setFontColorWithUpDownArrow(today_labour_cost_roster_diff, '$', true, 0) + targetImg + ' &nbsp; ' + '</span>' +
                    '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(today_labour_cost_ly_diff, '$', true, 0) + ' LY' + '</span>';
            }
            this.todayLabourCostBottom = label_1_2_labour_cost;

            // -------ITEM SOLD Card (Today Section)-------
            const today_items_sold = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.today_items_sold), 0);
            this.todayItemsSoldTop = today_items_sold;
            let label_1_2_items_sold = "-&nbsp;-";
            const last_year_same_day_items_sold = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.last_year_same_day_items_sold), 0);
            if (last_year_same_day_items_sold > 0) {
                const today_items_sold_ly_diff = this.setDecimalPoints(today_items_sold - last_year_same_day_items_sold);
                const today_items_sold_ly_per = this.setDecimalPoints((today_items_sold_ly_diff / last_year_same_day_items_sold) * 100, 1);
                label_1_2_items_sold =
                    '<span class="ly-row">' + this.setFontColorWithUpDownArrow(today_items_sold_ly_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
                    '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(today_items_sold_ly_diff, '', false, 0) + ' LY' + '</span>';
            }
            this.todayItemsSoldBottom = label_1_2_items_sold;

            // -------SALES / LABOUR HOUR Card (Today Section)-------
            let today_sales_by_labour_hour = 0;
            if (dash_board_data?.sales_today && dash_board_data?.today_labour_hours) {
                today_sales_by_labour_hour = this.setDecimalPoints(dash_board_data.sales_today / dash_board_data.today_labour_hours, 2);
            }
            this.todaySalesByLabourHourTop = today_sales_by_labour_hour;
            let label_1_2_sales_by_labour = "-&nbsp;-";
            let last_year_same_day_sales_value_by_labour_hour = 0;
            if (dash_board_data?.last_year_same_day_sales && dash_board_data?.last_year_same_day_labor_hours) {
                last_year_same_day_sales_value_by_labour_hour = this.setDecimalPoints(dash_board_data.last_year_same_day_sales / dash_board_data.last_year_same_day_labor_hours);
            }
            if (last_year_same_day_sales_value_by_labour_hour > 0) {
                const today_sales_by_labour_diff = this.setDecimalPoints(today_sales_by_labour_hour - last_year_same_day_sales_value_by_labour_hour);
                const today_sales_by_labour_per = this.setDecimalPoints((today_sales_by_labour_diff / last_year_same_day_sales_value_by_labour_hour) * 100, 1);
                label_1_2_sales_by_labour =
                    '<span class="ly-row">' + this.setFontColorWithUpDownArrow(today_sales_by_labour_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
                    '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(today_sales_by_labour_diff, '$', false) + ' LY' + '</span>';
            }
            this.todaySalesByLabourHourBottom = label_1_2_sales_by_labour;

            // -------SALES VALUE / ITEM Card (Today Section)-------
            let today_sales_value_by_item = 0;
            let label_1_2_sales_value_by_item = "-&nbsp;-";
            if (today_items_sold > 0) {
                today_sales_value_by_item = this.setDecimalPoints(dash_board_data.sales_today / today_items_sold, 2);
                let last_year_same_day_sales_value_by_item = 0;
                if (dash_board_data?.last_year_same_day_sales && dash_board_data?.last_year_same_day_items_sold) {
                    last_year_same_day_sales_value_by_item = this.setDecimalPoints(dash_board_data.last_year_same_day_sales / dash_board_data.last_year_same_day_items_sold, 2);
                }
                if (last_year_same_day_sales_value_by_item > 0) {
                    const today_sales_value_by_item_diff = this.setDecimalPoints(today_sales_value_by_item - last_year_same_day_sales_value_by_item);
                    const today_sales_value_by_item_per = this.setDecimalPoints((today_sales_value_by_item_diff / last_year_same_day_sales_value_by_item) * 100, 1);
                    label_1_2_sales_value_by_item =
                        '<span class="ly-row">' + this.setFontColorWithUpDownArrow(today_sales_value_by_item_per, '%', false, 1) + ' LY &nbsp; ' + '</span>' +
                        '<span class="ly-row mobile-break">' + this.setFontColorWithUpDownArrow(today_sales_value_by_item_diff, '$', false, 2) + ' LY' + '</span>';
                }
            } else {
                today_sales_value_by_item = 0;
                label_1_2_sales_value_by_item = '- -';
            }
            this.todaySalesValueByItemTop = today_sales_value_by_item;
            this.todaySalesValueByItemBottom = label_1_2_sales_value_by_item;

            // -------STAFF WORKING NOW Card (Today Section)-------
            const today_total_staffs_working = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.today_total_staffs_working), 0);
            this.todayStaffWorkingNowTop = today_total_staffs_working;
            const today_total_managers_working = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.today_total_managers_working), 0);
            const today_total_non_managers_working = this.setDecimalPoints(this.fnCheckNull(dash_board_data?.today_total_non_managers_working), 0);
            const label_1_2_staff_working = `${today_total_managers_working} M ${today_total_non_managers_working} S`;
            this.todayStaffWorkingNowBottom = label_1_2_staff_working;

        }
    }

    ngOnInit() {
    }
    setFontColorWithUpDownArrow(
        numberForSet: number,
        symbol: string = '',
        reverse: boolean = false,
        decimal: number = 1
    ): string {
        if (isNaN(numberForSet)) {
            return '-- ';
        }
        let baseNumber: string | number = numberForSet;
        let numberWithSymbol: string;

        if (symbol === '%') {
            baseNumber = Number(numberForSet).toLocaleString('en-US', {
                style: 'decimal',
                useGrouping: true,
                minimumFractionDigits: decimal,
                maximumFractionDigits: decimal,
            });
            numberWithSymbol = baseNumber + symbol;
        } else if (symbol === '$') {
            baseNumber = Number(numberForSet).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: decimal,
            });
            numberWithSymbol = baseNumber as string;
        } else {
            numberWithSymbol = Number(numberForSet).toLocaleString('en-US', {
                style: 'decimal',
                useGrouping: true,
                minimumFractionDigits: decimal,
            });
        }

        let arrow = '';
        if (Math.sign(numberForSet) === 1) {
            arrow = '▲';
        } else if (Math.sign(numberForSet) === -1) {
            arrow = '▼';
        }

        const compareValue = reverse ? numberForSet * -1 : numberForSet;

        if (Math.sign(compareValue) === 0) {
            return numberWithSymbol;
        } else if (Math.sign(compareValue) === 1) {
            let colorWithNumber = `<span class='cgreen'>${numberWithSymbol}${arrow}</span>`;
            colorWithNumber = colorWithNumber.replace('-', '');
            return colorWithNumber;
        } else if (Math.sign(compareValue) === -1) {
            let colorWithNumber = `<span class='cred'>${numberWithSymbol}${arrow}</span>`;
            colorWithNumber = colorWithNumber.replace('-', '');
            return colorWithNumber;
        } else {
            return numberWithSymbol;
        }
    }

    setDecimalPoints(value: number, decimal: number = 1): number {
        return Number(Number(value).toFixed(decimal));
    }

        fnCheckNull(a: any): number {
        return a == null ? 0 : a;
    }

}
